import type { AxiosResponse } from "axios";

import { getData, postData } from "@/apis/apiInstance";

import type {
  GetSchedulingNotificationCountPayloadType,
  GetSchedulingNotificationPayloadType,
  postSchedulingNotificationClearPayloadType,
} from "@/commonTypes/notificationType";

import { getCSRFToken } from "@/utils/commonFunctions";

export async function getSchedulingNotificationApi(
  data: GetSchedulingNotificationPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, platform } = data;
  return await getData(`notification-module/finac/notification/list`, {
    // return await (getData(`notification-module/scheduling/notification/list`, {
    params: {
      limit,
      offset,
      platform,
    },
    headers: {
      "Content-type": "application/json",
      "user-token": token,
    },
  });
}

export async function getSchedulingNotificationCountApi(
  data: GetSchedulingNotificationCountPayloadType
): Promise<AxiosResponse> {
  const { token } = data;
  return await getData(`notification-module/finac/notification/count`, {
    headers: {
      "Content-type": "application/json",
      "user-token": token,
    },
  });
}

export async function postSchedulingNotificationClearApi(
  data: postSchedulingNotificationClearPayloadType
): Promise<AxiosResponse> {
  const { token, params } = data;

  return await postData(
    `/notification-module/clear-all/marked-all/notifications`,
    params,
    {
      headers: {
        "Content-type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}
